export interface Faq {
  q: string;
  a: string;
}

export const faqs: Faq[] = [
  {
    q: "什么是火影同人作品？",
    a: "火影同人作品是指由粉丝基于《火影忍者》原作世界观与角色进行的二次创作，包括原创剧情、角色情感延伸、平行世界设定等。本站收录的作品均来自同人创作者，与官方正传相互独立，为热爱忍界的读者带来全新的故事体验。",
  },
  {
    q: "网站按什么方式分类同人作品？",
    a: "本站以角色为核心进行分类，例如日向雏田同人、春野樱同人、纲手同人、宇智波佐助同人、漩涡鸣人同人等。你可以进入角色专区或同人作品列表，按角色快速筛选自己感兴趣的内容。",
  },
  {
    q: "同人作品的内容是免费阅读的吗？",
    a: "是的。本站仅提供同人作品的角色分类、简介与推荐信息，帮助读者发现优质内容。作品正文的阅读与分享由创作者决定，我们坚持尊重每一位创作者的努力与版权。",
  },
  {
    q: "作品多久更新一次？",
    a: "我们每周都会更新一批新的同人作品与角色资料，热门角色如日向雏田、春野樱、纲手等的专区会优先补全。你可以订阅本站的更新通知，第一时间获取新作品动态。",
  },
  {
    q: "我可以投稿自己的火影同人作品吗？",
    a: "当然可以。我们欢迎所有热爱火影、用心创作的同人作者。你可以在本站留下投稿意向，并附上作品标题、所属角色与简介，我们会尽快审核并联系你，共同完善角色专区的内容。",
  },
  {
    q: "这些同人作品是官方授权的吗？",
    a: "本站为粉丝同人内容分享平台，与《火影忍者》原作及版权方无隶属关系。所有同人作品均为粉丝爱好的二次创作，我们严格遵守相关版权规定，只做内容展示与推荐。",
  },
];

export const faqStructuredData = faqs.map((f) => ({
  "@type": "Question",
  name: f.q,
  acceptedAnswer: { "@type": "Answer", text: f.a },
}));